<template>
    <div class="header-block">
        <img
            class="main-logo"
            :src="require('@/assets/main_logo.png')"
            alt="Main logo"
        >
        <v-card color="#232323" class="header-card rounded-lg" style="min-width: 350px;">
            <div class="custom-teal-text font-weight-bold py-6 px-10">
                {{ title }}
            </div>
        </v-card>
        <v-card color="#232323" class="header-card rounded-lg" style="min-width: 500px;">
            <div class="white--text font-weight-bold py-6 px-10">
                {{ roundLabel }}
            </div>
        </v-card>
    </div>
</template>

<script>
    export default {
        name: 'MatchInfoHeader',
        props: {
            match: {
                type: Object,
                required: true
            }
        },
        computed: {
            // the cup, the league, or a friendly
            title() {
                if (this.match.cupLeague) return this.match.cupLeague.title
                if (this.match.league) return this.match.league.title
                return 'Friendly'
            },
            roundLabel() {
                const phaseLabel = this.match.cup
                    ? 'Κύπελλο'
                    : (this.match.phase === 'regular_season' ? 'Regular Season' : (this.match.phase === 'placements' ? 'Προκριματικά' : (this.match.phase === 'playoffs' ? 'Play Offs' : 'Friendly Match')))
                return this.match.round > 0 ? `Matchday ${this.match.round}, ${phaseLabel}` : phaseLabel
            }
        }
    }
</script>

<style scoped>
.header-block {
    position: absolute;
    top: 12px;
    left: 105px;
    z-index: 5;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
}

.main-logo {
    width: clamp(160px, 24vw, 280px);
    height: auto;
    pointer-events: none;
}

.header-card {
    border-top: 3px solid #03e5b7 !important;
    font-family: 'Squada One', 'Roboto Condensed', Arial, sans-serif;
    letter-spacing: 0.03em;
}
</style>
